import { UIAlert, UIBox } from "../../_app/components";
import Tabbed from "../../_app/layouts/Tabbed";
import { createStylesheet } from "../../_app/utils/styles";

interface Props {
  selectedTab: string;
  children: any;
}

function ManageUsersTabBar({ selectedTab, children }: Props) {
  const classes = useStyles();
  const getInfoText = () => {
    if (selectedTab === "users") {
      return "Administer portal access by regulating user permissions and defining their capabilities within your account. Modifications will solely impact portal access.";
    }
    if (selectedTab === "roles") {
      return "Easily manage your user permissions using Roles. Create your Roles here and set it’s permissions, then simply assign the Role to the relevant users. They will then inherit the permissions of the role.";
    }
  };
  return (
    <UIBox className={classes.wrap}>
      <UIAlert severity="info" className={classes.info}>
        {getInfoText()}
      </UIAlert>
      <Tabbed
        selectedTab={selectedTab}
        tabs={[
          {
            value: "users",
            label: "Users",
          },
          {
            value: "roles",
            label: "Roles",
          },
        ]}
      >
        {children}
      </Tabbed>
    </UIBox>
  );
}

const useStyles = createStylesheet((theme) => ({
  wrap: {
    width: "100%",
  },
  info: {
    width: "fit-content",
    alignItems: "center",
    marginBottom: theme.spacing(1),
    "& a": {
      textDecoration: "none",
      color: theme.palette.primary.main,
    },
  },
}));

export default ManageUsersTabBar;
